export const REPORTINVOICE_SEARCH = 'REPORTINVOICE_SEARCH';
export const REPORTINVOICE_PAGE = 'REPORTINVOICE_PAGE';
export const REPORTINVOICE_MONTH = 'REPORTINVOICE_MONTH';
export const REPORTINVOICE_YEAR = 'REPORTINVOICE_YEAR';
export const REPORTINVOICE_INVOICESTATUS = 'REPORTINVOICE_INVOICESTATUS';